import React from 'react';

const DetailRow = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className="flex flex-row justify-between w-full">{children}</div>;
};

export default DetailRow;
